<template>
    <div>
        <v-card>
            <v-card-title class="primary white--text">
                <v-flex xs12 md10>
                    Reporte evento: <b>{{event.description}}</b>
                </v-flex>
            <v-flex xs12 md2>
                <v-btn
                medium
                :loading="loading"
                :disabled="loading"
                @click="downloadReport"
                dark
                >
                <v-icon left dark>cloud_download</v-icon>
                Descargar
                </v-btn>
            </v-flex>
            </v-card-title>  
             <v-card-text>
                <v-layout wrap>
                    <!-- <v-flex
                    xs12
                    md2
                    class="card-info"
                    >
                        <v-sheet
                            :elevation="6"
                            class="mx-auto info-container circle-container"
                            height="120"
                            width="100"
                        >
                            <div class="info-title circle"><span>Asistencia</span></div>
                            <v-progress-circular
                            :rotate="-90"
                            :size="75"
                            :width="15"
                            :value="assembly.status === 0 ? actualPercent : assembly.attendance_percentage"
                            color="teal"
                            >
                            {{ assembly.status === 0 ? actualPercent : assembly.attendance_percentage }}%
                            </v-progress-circular>
                        </v-sheet>
                    </v-flex> -->

                    <v-flex
                        xs12
                        md2
                        class="card-info"
                        >
                        <v-sheet
                            :elevation="6"
                            class="mx-auto info-container"
                            height="100"
                            width="100"
                        >
                            <div class="info-title"><span>Familias</span></div>
                            <div class="info-data">
                            <span>{{familyData.length}}</span>
                            </div>
                        </v-sheet>
                    </v-flex>
                    <v-flex
                        xs12
                        md2
                        class="card-info"
                        >
                        <v-sheet
                            :elevation="6"
                            class="mx-auto info-container"
                            height="100"
                            width="100"
                        >
                            <div class="info-title"><span>Asistencia</span></div>
                            <div class="info-data">
                            <span>{{assists.length}}</span>
                            </div>
                        </v-sheet>
                    </v-flex>
                    <v-flex
                        xs12
                        md2
                        class="card-info"
                        >
                        <v-sheet
                            :elevation="6"
                            class="mx-auto info-container"
                            height="100"
                            width="100"
                        >
                            <div class="info-title"><span>Lower Elementary</span></div>
                            <div class="info-data">
                            <span>{{lower_elementary}}</span>
                            </div>
                        </v-sheet>
                    </v-flex>
                    <v-flex
                        xs12
                        md2
                        class="card-info"
                        >
                        <v-sheet
                            :elevation="6"
                            class="mx-auto info-container"
                            height="100"
                            width="100"
                        >
                            <div class="info-title"><span>Upper elementary</span></div>
                            <div class="info-data">
                            <span>{{upper_elementary}}</span>
                            </div>
                        </v-sheet>
                    </v-flex>
                    <v-flex
                        xs12
                        md2
                        class="card-info"
                        >
                        <v-sheet
                            :elevation="6"
                            class="mx-auto info-container"
                            height="100"
                            width="100"
                        >
                            <div class="info-title"><span>Middle School</span></div>
                            <div class="info-data">
                            <span>{{middle_school}}</span>
                            </div>
                        </v-sheet>
                    </v-flex>
                    <v-flex
                        xs12
                        md2
                        class="card-info"
                        >
                        <v-sheet
                            :elevation="6"
                            class="mx-auto info-container"
                            height="100"
                            width="100"
                        >
                            <div class="info-title"><span>High School</span></div>
                            <div class="info-data">
                            <span>{{high_school}}</span>
                            </div>
                        </v-sheet>
                    </v-flex>

                </v-layout>    
             </v-card-text>
        </v-card>
        <div class="space"></div>
        <v-card>
            <v-card-title>
            <v-text-field
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
            ></v-text-field>
            </v-card-title>
            <v-data-table
            :headers="headers"
            :items="assists"
            :search="search"
            >
            <template slot="items" slot-scope="props">
                <td class="text-xs-center">{{ props.item[0].family }}</td>
                <td class="text-xs-center" v-if="!props.item[0].assist.delegate_allowed">{{ props.item[0].assist.father }}</td>
                <td class="text-xs-center" v-else>{{ props.item[0].assist.delegate }}</td>
                <td class="text-xs-center" v-if="!props.item[0].assist.delegate_allowed">{{ props.item[0].assist.mother }}</td>
                <td class="text-xs-center" v-else>{{ props.item[0].assist.delegate }}</td>
                <td class="text-xs-center" v-if="props.item[0].assist.assistFather">{{ props.item[0].total_families.father_email }}</td>
                <td class="text-xs-center" v-else-if="props.item[0].assist.assistMother">{{ props.item[0].total_families.mother_email }}</td>
                <td class="text-xs-center" v-else>{{ props.item[0].assist.father_email }}-{{ props.item[0].total_families.mother_email }}</td>

                <td class="text-xs-center" v-if="props.item[0].assist.assistFather && props.item[0].assistMother">Padres</td>
                <td class="text-xs-center" v-else-if="props.item[0].assist.assistFather">Papá</td>
                <td class="text-xs-center" v-else-if="props.item[0].assist.assistMother">Mamá</td>
                <td class="text-xs-center" v-else>Delegado</td>
                <td class="text-xs-center">{{ props.item[0].assist.observation }}</td>                
                <td class="text-xs-center">{{ props.item[0].assist.date }}</td>                
                <td class="text-xs-center">
                <v-btn v-if="props.item[0].assist.signatureUrl" color="primary" small @click="seeSignature(props.item[0].assist.signatureUrl)">Ver firma</v-btn>
                </td>
            </template>
            </v-data-table>
        </v-card>
        <v-dialog
            v-model="dialog"
            width="500"
        >
            <v-card>
                <v-img
                :src="signature_url"
                aspect-ratio="1"
                class="grey lighten-2"
                contain
                height="250"
                />
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    flat
                    @click="dialog = false"
                >
                    Cerrar
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    data () {
        return {
          upper_elementary: [],
          lower_elementary: [],
          middle_school :  [],
          high_school : [],
          event: [],  
          familyData: [],
          assists: [
          ],
          loading: false,
          search: '',
            headers: [
                { text: 'Familia', align: 'center', value: 'family', sortable: true },
                { text: 'Padre', align: 'center', value: 'father', sortable: false },
                { text: 'Madre', align: 'center', value: 'mother', sortable: false },
                { text: 'Correo', align: 'center', value: 'mother', sortable: false },
                { text: 'Asistente', align: 'center', value: 'date', sortable: false },
                { text: 'Observación', align: 'center', value: 'observation', sortable: false },
                { text: 'Fecha Asistencia', align: 'center', value: 'date', sortable: false },
                { text: 'Firma', align: 'center', value: 'signatureUrl', sortable: false }
            ],
             dialog: false,
             signature_url: '',
        }
    },
    methods: {
        downloadReport () {
             this.loading = true;
            axios({
                 url: `/api/download/report/event/${this.$route.params.id}`,
                 method: 'GET',
                 responseType: 'blob',
            })
            .then(resp=>{
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(new Blob([resp.data]));
                link.setAttribute('download', `event_${this.event.description}_report.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.loading = false;
                this.$store.dispatch('responseMessage', {
                    type: 'success',
                    title: 'Noticia',
                    text: 'Archivo descargado con éxito, por favor consulte la carpeta de descargas',
                    modal: true
                })
            })
            .catch(err=>{
                this.loading = false;
                console.log(err)
            })
        },
        family () {
            axios.get('/api/families').then(resp=>{
                this.familyData = resp.data
            })
        },
        async eventGet () {
            await axios.get('/api/events/get/' + this.$route.params.id).
            then( resp=>{
                const { data, status } = resp;
                this.event = data;
                this.gradeFamily()
            })
        },
        seeSignature (url) {
            this.signature_url = url;
            this.dialog = true;
        },
        loadData () {
            axios.get('/api/events/report/' + this.$route.params.id)
            .then(resp=>{
                this.familyData = resp.data.total_families;
                let data = JSON.parse(resp.data.assitance)
                let total_families = resp.data.total_families;
                data.forEach(element => {
                    total_families.forEach(elementFamily =>{
                        if(element.familyId==elementFamily.username){
                            this.assists.push([{assist: element, total_families: elementFamily}])
                        }
                    });
                });
                console.log("data", this.assists)

            }).catch(err=>{
                console.log(err)
            }) 
        },
        gradeFamily(data) {
            axios.post('api/events/family/grade', this.event)
            .then(resp=>{
                console.log('Grade', resp.data)
            this.upper_elementary = resp.data.upper_elementary;
            this.middle_school =  resp.data.middle_school;
            this.high_school = resp.data.high_school;
            this.lower_elementary = resp.data.lower_elementary;

            })
        }
    },
    created () {
        this.loadData();            
        this.eventGet();
    },
    mounted () {
        // this.family()
    }
}
</script>

<style>
.info-container {
  display: flex;
  flex-direction: column;
}

.circle-container {
  padding: 0px 10px 0px 10px;
}

.circle {
  margin-bottom: 3px;
}

.info-title {
  padding: 10px;
  background-color: #fff;
  color: #000;
  font-weight: 600;
  font-size: 12px;
  text-align: center;
  border-bottom: 1px solid lightgray;
}

.info-data {
  background-color: #fff;
  color: #000;
  font-weight: 600;
  text-align: center;
  vertical-align: middle;
  padding-top: 20px;
}

.card-info {
  margin-top: 10px;
}

</style>





// WEBPACK FOOTER //
// resources/assets/js/pages/event/report.vue